import {
  Text,
  Box,
  Img,
  HStack,
  Heading,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverArrow,
  PopoverCloseButton,
  Input,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
// import {

// } from "@chakra-ui/react";

import gs12 from "../../Assets/gs12.png";

export const Navbar = () => {
  const navigate = useNavigate();
  return (
    <Box
      backgroundImage={
        "https://res.cloudinary.com/urbanclap/image/upload/images/growth/home-screen/1615375782838-f890f8.jpeg"
      }
      height={"70vh"}
      backgroundPosition={"center"}
      width={"100%"}
    >
      <Box pt={"10px"} width={"80%"} justifyContent={"center"} alignContent={"center"} margin={"auto"}>
        <HStack justifyContent={"space-between"}>
          <Box width={"37%"}>
            <Img src={gs12} bgColor="transparent" width={"21%"} />
          </Box>
          <HStack width={"30vw"} justifyContent={"space-around"} color={"white"}>
            <Text fontSize="md" as={"b"}>
              Blog
            </Text>
            <Text fontSize="md" as={"b"}>
              Register As A Professional
            </Text>
            <Text fontSize="md" as={"b"}>
              Help Center
            </Text>
            <Text fontSize="md" as={"b"}>
              Login/Signup
            </Text>
          </HStack>
        </HStack>
      </Box>
      <Box width={"60%"} right={0} left={0} margin={"auto"}>
        <Box>
          <Box pt={"10vh"} pb={"10vh"} color={"white"} backgroundColor={"transparent"}>
            <Text as={"b"} fontSize={"x-small"}>
              Home / Delhi NCR
            </Text>
          </Box>
          <Box color={"white"} fontSize={"30px"} mb={"10"}>
            <Heading width={"100%"} textAlign={"center"}>
              Home Services, On Demand.
            </Heading>
          </Box>
          <Box display={"flex"} justifyContent={"space-around"} w={"50%"} margin={"auto"}>
            <Box>
              <Popover>
                <PopoverTrigger>
                  <Box
                    width={"7vw"}
                    height={"45px"}
                    h={"42px"}
                    textAlign={"center"}
                    borderRadius={"7px"}
                    bgColor={"white"}
                    color="black"
                    fontSize={"23px"}
                    cursor={"pointer"}
                  >
                    Delhi NCR
                  </Box>
                </PopoverTrigger>
                <PopoverContent>
                  <PopoverArrow />
                  <PopoverCloseButton />
                  <PopoverHeader>
                    <Box
                      flexDirection={"row"}
                      pr={"4px"}
                      pl={"4px"}
                      display={"flex"}
                      alignItems={"center"}
                      justifyContent={"space-between"}
                    >
                      <Text fontSize={"14px"}>Current Location</Text>
                      <Text fontSize={"14px"}>Detect Using GPS-</Text>
                    </Box>
                  </PopoverHeader>
                  <PopoverBody>
                    <Input type={"search"} backgroundColor={"white"} placeholder="Search for society/Apartment" />
                  </PopoverBody>
                </PopoverContent>
              </Popover>
            </Box>
            <Box alignItems={"center"} justifyContent={"space-between"} gap={"20px"}>
              <HStack
                width={"30vw"}
                justifyContent={"start"}
                color={"white"}
                display={"flex"}
                flexDirection={"column"}
                textAlign={"start"}
              >
                <Input
                  type={"search"}
                  left={"20px"}
                  placeholder={"Search for Services"}
                  backgroundColor={"white"}
                  color={"white"}
                  height={"45px"}
                  p={"10px"}
                />
                <Text fontSize="md" as={"u"} fontWeight={"medium"}>
                  Women's Therpeies , Salon for men, Mens's Tharpies, etc.
                </Text>
              </HStack>
            </Box>
          </Box>
        </Box>
        <Box
          height={"150px"}
          width={"70%"}
          display={"flex"}
          backgroundColor={"white"}
          zIndex={"100"}
          margin={"auto"}
          mt={"130px"}
          gap={"50px"}
          p={"10"}
          border={"2px solid black"}
        >
          <Box
            onClick={() => {
              navigate("/product?service=salon%20prime");
            }}
            alignItems={"center"}
            justifyContent={"center"}
            margin={"auto"}
          >
            <Img
              src="https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_64/t_high_res_template/images/growth/home-screen/1609757635235-1a139e.png"
              w={"32px"}
              h={"32px"}
              margin={"auto"}
              mb={"10px"}
            />
            <Text textAlign={"center"} fontSize={"small"} color={"black"}>
              Salon for Women
            </Text>
          </Box>
          <Box onClick={() => {
              navigate("/product?service=women%20hair%20service");
            }} alignItems={"center"} justifyContent={"center"} margin={"auto"}>
            <Img
              src="https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_64/t_high_res_template/images/supply/customer-app-supply/1635331606894-7b633f.png"
              w={"32px"}
              h={"32px"}
              margin={"auto"}
              mb={"10px"}
            />
            <Text textAlign={"center"} fontSize={"small"} color={"black"}>
              Hair, skin & nails
            </Text>
          </Box>
          <Box onClick={() => {
              navigate("/product?service=spa%20at%20home");
            }} alignItems={"center"} justifyContent={"center"} margin={"auto"}>
            <Img
              src="https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_64/t_high_res_template/images/growth/home-screen/1609757731250-ba3308.png"
              w={"32px"}
              h={"32px"}
              margin={"auto"}
              mb={"10px"}
            />
            <Text textAlign={"center"} fontSize={"small"} color={"black"}>
              Womens Therpaies
            </Text>
          </Box>
          <Box onClick={() => {
              navigate("/product?service=mens%20grooming");
            }} alignItems={"center"} justifyContent={"center"} margin={"auto"}>
            <Img
              src="https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_64/t_high_res_template/images/growth/home-screen/1609757629780-2b2187.png"
              w={"32px"}
              h={"32px"}
              margin={"auto"}
              mb={"10px"}
            />
            <Text textAlign={"center"} fontSize={"small"} color={"black"}>
              Salon for men
            </Text>
          </Box>
          <Box onClick={() => {
              navigate("/product?service=massage%20for%20mens");
            }} alignItems={"center"} justifyContent={"center"} margin={"auto"}>
            <Img
              src="https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_64/t_high_res_template/images/growth/home-screen/1609757731250-ba3308.png"
              w={"32px"}
              h={"32px"}
              margin={"auto"}
              mb={"10px"}
            />
            <Text textAlign={"center"} fontSize={"small"} color={"black"}>
              Men's Therapies
            </Text>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
